import React from 'react'
import PageLoader from 'components/GeneralComponents/Loaders/PageLoader'
import ParticlesOverlay from 'components/LayoutComponents/ParticlesOverlay'

const LoadingPage = () => {
  return (
    <ParticlesOverlay fullscreen>
      <PageLoader />
    </ParticlesOverlay>
  )
}

export default LoadingPage
